import styled from "styled-components";
import Modal from "@iso/components/Feedback/Modal";
import WithDirection from "@iso/lib/helpers/rtl";

const FileBrowserWrapper = styled(Modal)`
  .ant-modal-body {
    padding: 0;
  }

  .ant-modal-footer .ant-btn + .ant-btn:not(.ant-dropdown-trigger) {
    margin-left: 0;
  }

  /* Scope tabs (My Files / Corporate Library) - card style */
  > .ant-modal-body > .scope-tabs > .ant-tabs-nav {
    padding: 0 24px;
    margin-bottom: 0;
  }

  > .ant-modal-body > .scope-tabs > .ant-tabs-content {
    padding: 0;
  }

  .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab-active {
    border-bottom-color: #fff;
  }

  /* Inner tabs (Library / Upload) and direct tabs when no corporate group */
  .ant-tabs-nav {
    padding: 0 24px;
    margin-bottom: 0;
  }

  .ant-tabs-content {
    padding: 16px 24px;
  }

  .folder-breadcrumb-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    padding: 8px 12px;
    background: #fafafa;
    border-radius: 6px;

    .ant-breadcrumb a {
      color: #0B2A1B;
    }
  }

  .folder-card {
    border: 2px solid #e8e8e8;
    border-radius: 8px;
    padding: 12px 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    text-align: center;
    position: relative;

    &:hover {
      border-color: #0B2A1B;
      background-color: rgba(11, 42, 27, 0.02);
    }

    .folder-actions {
      position: absolute;
      top: 4px;
      right: 4px;
      opacity: 0;
      transition: opacity 0.2s;
    }

    &:hover .folder-actions {
      opacity: 1;
    }

    .folder-icon {
      font-size: 36px;
      color: #faad14;
      margin-bottom: 6px;
    }

    .folder-name {
      font-size: 12px;
      font-weight: 500;
      color: #333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .folder-meta {
      font-size: 11px;
      color: #999;
      margin-top: 2px;
    }
  }

  .search-filter-bar {
    display: flex;
    gap: 12px;
    margin-bottom: 16px;

    .file-search-input {
      flex: 1;
      border-radius: 8px;
      height: 40px;

      input {
        border: none !important;
        &:focus {
          box-shadow: none;
        }
      }

      &.ant-input-affix-wrapper-focused,
      &:hover {
        box-shadow: none;
        border-color: #0B2A1B;
      }
    }

    .type-filter {
      min-width: 150px;
      height: 40px;

      .ant-select-selector {
        height: 40px !important;
        border-radius: 8px !important;
        display: flex;
        align-items: center;
      }
    }
  }

  .library-grid {
    min-height: 300px;
  }

  .file-card {
    border: 2px solid #e8e8e8;
    border-radius: 8px;
    padding: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-bottom: 12px;
    position: relative;

    &:hover {
      border-color: #0B2A1B;
    }

    &.selected {
      border-color: #0B2A1B;
      background-color: rgba(11, 42, 27, 0.04);
    }

    .file-thumbnail {
      width: 100%;
      height: 120px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      border-radius: 4px;
      background-color: #fafafa;
      margin-bottom: 8px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .file-type-icon {
        font-size: 40px;
        color: #999;
      }
    }

    .file-name {
      font-size: 12px;
      color: #333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .file-type-badge {
      font-size: 11px;
      color: #999;
      text-transform: uppercase;
    }

    .selection-indicator {
      position: absolute;
      top: 8px;
      right: 8px;
    }

    .file-card-actions {
      position: absolute;
      top: 8px;
      right: 8px;
      display: flex;
      gap: 2px;
      opacity: 0;
      transition: opacity 0.2s;
      background: rgba(255, 255, 255, 0.9);
      border-radius: 4px;
      padding: 2px;
      z-index: 1;

      .ant-btn {
        width: 28px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    &:hover .file-card-actions {
      opacity: 1;
    }
  }

  .pagination-bar {
    display: flex;
    justify-content: center;
    margin-top: 16px;
  }

  .upload-tab-content {
    padding: 16px 0;

    .upload-hint {
      margin-bottom: 16px;
    }

    .ant-alert-info {
      background-color: #fff;
    }

    .upload-drop-zone {
      border: 2px dashed #d9d9d9;
      border-radius: 8px;
      padding: 40px 20px;
      text-align: center;
      cursor: pointer;
      transition: all 0.2s ease;
      background: #fafafa;

      &:hover {
        border-color: #0B2A1B;
        background: rgba(11, 42, 27, 0.02);
      }

      &.drag-over {
        border-color: #0B2A1B;
        background: rgba(11, 42, 27, 0.06);
        border-style: solid;
      }

      &.uploading {
        cursor: default;
        opacity: 0.7;
      }

      .drop-zone-icon {
        font-size: 48px;
        color: #0B2A1B;
        margin-bottom: 12px;
      }

      .drop-zone-title {
        font-size: 16px;
        font-weight: 500;
        color: #333;
        margin-bottom: 4px;
      }

      .drop-zone-subtitle {
        font-size: 13px;
        color: #999;
        margin: 0;
      }
    }

    .folder-upload-progress {
      margin-top: 16px;

      .folder-upload-list {
        max-height: 200px;
        overflow-y: auto;
        margin-top: 8px;
        background:
          linear-gradient(white 30%, rgba(255, 255, 255, 0)) center top,
          linear-gradient(rgba(255, 255, 255, 0), white 70%) center bottom,
          radial-gradient(farthest-side at 50% 0, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0)) center top,
          radial-gradient(farthest-side at 50% 100%, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0)) center bottom;
        background-repeat: no-repeat;
        background-size: 100% 40px, 100% 40px, 100% 10px, 100% 10px;
        background-attachment: local, local, scroll, scroll;

        .ant-list-item {
          padding: 4px 0;
          gap: 8px;
        }

        .folder-upload-filename {
          font-size: 12px;
          color: #666;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }

  .footer-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .selected-count {
      color: #666;
      font-size: 13px;
      margin-right: 12px;
    }

    .footer-actions {
      display: flex;
      gap: 8px;
    }
  }
`;

export default WithDirection(FileBrowserWrapper);
